document.addEventListener("DOMContentLoaded", function () {
  const readMoreButtons = document.querySelectorAll(".read-more-button");

  if (readMoreButtons && readMoreButtons.length) {
    readMoreButtons.forEach(function (readMoreButton) {
      readMoreButton.addEventListener("click", function () {
        const parentNode = this.parentNode;
        const readMoreContainer = parentNode.querySelector(
          ".read-more-container"
        );

        if (readMoreContainer) {
          if (readMoreContainer.classList.contains("expanded")) {
            readMoreContainer.classList.remove("expanded");
            readMoreButton.classList.remove("expanded");
            readMoreContainer.style.maxHeight = "";
          } else {
            readMoreContainer.classList.add("expanded");
            readMoreButton.classList.add("expanded");
            readMoreContainer.style.maxHeight =
              readMoreContainer.scrollHeight + "px";
          }
        }
      });
    });
  }

  const mobNavLinks = document.querySelectorAll(
    ".key-markets-archive__nav-item"
  );

  const readMoreButton = document.querySelector(
    ".key-markets-archive__mobile-nav-toggle"
  );
  const readMoreContainer = document.querySelector(
    ".key-markets-archive__nav-items-wrapper"
  );

  mobNavLinks.forEach(function (mobNavLink) {
    mobNavLink.addEventListener("click", function () {
      readMoreContainer.classList.remove("expanded");
      readMoreButton.classList.remove("expanded");
      readMoreContainer.style.maxHeight = "";
    });
  });
});
